import actionTypes from './action-types';
import initialState from './initial-state';
import modalState from './modal-state';

export default (state = initialState, action) => {
    if (!action || !action.type) return state;
    switch (action.type) {
        case actionTypes.RESET:
            return { ...initialState };
        case actionTypes.COMPLETED:
            return { ...state, modalState: modalState.COMPLETED };
        case actionTypes.SET_ERROR:
            return {
                ...state,
                errorMessage: action.payload,
                modalState: modalState.ERROR
            };
        case actionTypes.IN_PROGRESS:
            return {
                ...state,
                autoStartToken: action.payload
            };
        case actionTypes.START_AUTH:
            return {
                ...state,
                errorMessage: null,
                retryCount: 0,
                modalState: modalState.IN_PROGRESS
            };
        case actionTypes.CLOSE:
            return {
                ...state,
                modalState: modalState.CLOSED
            };
        default:
            return state;
    }
};
